import React from 'react';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { cn } from '@/lib/utils';
import type { DiretoriaExecutiveCard } from '@/lib/diretoriaDashboard';
import { diretoriaToneTextClass } from '@/lib/diretoriaKpiTone';

export const DiretoriaExecutiveStrip: React.FC<{ cards: DiretoriaExecutiveCard[] }> = ({ cards }) => {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
      {cards.map((card) => (
        <Card key={card.id} className="border-border/80 shadow-soft-sm">
          <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-2">
            <CardTitle className="text-xs font-medium leading-tight text-muted-foreground">{card.label}</CardTitle>
            {card.source === 'api' || card.source === 'erp' ? (
              <Badge variant="default" className="shrink-0 scale-90">
                {card.source === 'api' ? 'Cobrança' : 'ERP'}
              </Badge>
            ) : null}
          </CardHeader>
          <CardContent className="space-y-1 pt-0">
            <div
              className={cn(
                'font-heading text-xl font-bold tabular-nums tracking-tight sm:text-2xl',
                diretoriaToneTextClass(card.valueTone)
              )}
            >
              {card.value}
            </div>
            {card.sublabel ? <p className="text-[11px] leading-snug text-muted-foreground">{card.sublabel}</p> : null}
            {card.trend ? (
              <div
                className={cn(
                  'flex items-center gap-1 text-[11px] font-medium',
                  card.trendPositive === true && 'text-emerald-600 dark:text-emerald-400',
                  card.trendPositive === false && 'text-rose-600 dark:text-rose-400',
                  card.trendPositive === undefined && 'text-muted-foreground'
                )}
              >
                {card.trendPositive === true ? (
                  <TrendingUp className="h-3 w-3 shrink-0" aria-hidden />
                ) : card.trendPositive === false ? (
                  <TrendingDown className="h-3 w-3 shrink-0" aria-hidden />
                ) : null}
                <span>{card.trend}</span>
              </div>
            ) : null}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
